import React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./apollo/client";
import { brandConfig } from "./brandConfig";
import theme from "./theme";

// Pages
import Home from "./pages/Home";
import Success from "./pages/Success";
import DavesFeast from "./pages/DavesFeast";
import BeachDinner from "./pages/BeachDinner";

export const App = () => {
  React.useEffect(() => {
    const storedTenantId = localStorage.getItem('tenantId');
    if (!storedTenantId) {
      if (brandConfig.tenantId) {
        localStorage.setItem('tenantId', brandConfig.tenantId);
      }
    }
  }, []);

  return (
    <Router>
      <ApolloProvider client={apolloClient}>
        <ChakraProvider theme={theme}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/success" element={<Success />} />
            <Route path="/daves-feast" element={<DavesFeast />} />
            <Route path="/beach-dinner" element={<BeachDinner />} />
          </Routes>
        </ChakraProvider>
      </ApolloProvider>
    </Router>
  );
};
